//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 05/08/2024
// Version : 1
// Description : tabla de tanques
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/system";
import dayjs from "dayjs";

function Tabla_tanque(props) {
  const [cantidadTanque, setCantidadTanque] = useState([]);
  const { selectedDate } = props;

  const obtenerCantidadTanque = () => {
    const formattedDate = selectedDate.format("YYYY"); // Formatear la fecha seleccionada
    fetch(UrlApi + "/reclamos/cantidadTanques/fecha/" + formattedDate)
      .then((data) => data.json())
      .then((data) => setCantidadTanque(data));
  };
  useEffect(() => {
    obtenerCantidadTanque();
  }, [selectedDate]);

  // console.log("CANTIDAD TANQUE", cantidadTanque);

  const paperStyle3 = {
    padding: "10px",
    // margin: "10px",
    // width: "1200px",
  };
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  // console.log("AÑO ACTUAL: ", currentYear);

  const todosLosMeses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const obtenerNombreMes = (fecha) => {
    const mes = dayjs(fecha, "YYYY-MM").format("M") - 1; // Extraer el mes (0-11)
    return todosLosMeses[mes];
  };

  const transformarDatosParaTabla = (data) => {
    if (!data || data.length === 0) {
      return { dataset: [], tanques: [], meses: todosLosMeses };
    }

    const tanques = Object.keys(data[0]).filter((key) => key !== "fecha");
    const meses = todosLosMeses;

    // Crear el dataset para la tabla utilizando .map
    const dataset = tanques.map((tanque) => {
      const fila = { tanque };
      meses.forEach((mes) => {
        const item = data.find((item) => obtenerNombreMes(item.fecha) === mes);
        fila[mes] = item ? item[tanque] || 0 : 0;
      });
      return fila;
    });

    return { dataset, tanques, meses };
  };

  const { dataset, tanques, meses } = transformarDatosParaTabla(cantidadTanque);

  const HeaderCell = styled(TableCell)({
    marginTop: "2px",
    fontSize: 13,
    color: "white",
    fontWeight: "normal",
    backgroundColor: "#2471A3",
    borderColor: "white",
    padding: "6.3px",
  });

  return (
    <div>
      <Paper elevation={10} style={{ ...paperStyle3 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            align="center"
            style={{
              fontWeight: "bold",
              fontSize: 20,
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            Tanques
          </Typography>
        </div>
        <TableContainer sx={{ maxHeight: 500, overflowX: "auto" }}>
          <Table
            sx={{ minWidth: 300, marginTop: 2 }}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
               <HeaderCell
                  align="center"
                  sx={{ border: "1px solid black", position: "relative" }}
                >
                  <div
                    style={{
                      width: "100%",
                      border: "none",
                      transformOrigin: "center",
                    }}
                  >
                    <b>Meses</b>
                    <hr
                      style={{
                        width: "100%",
                        border: "none",
                        borderTop: "1px solid black",
                        transformOrigin: "center",
                      }}
                    />
                    <b>Tanque</b>
                  </div>
                </HeaderCell>
                {meses.map((mes, index) => (
                  <TableCell
                    key={index}
                    align="center"
                    sx={{
                      backgroundColor: "#2B76A6",
                      color: "white",
                      border: "1px solid black",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    {mes}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tanques.map((tanque, index) => (
                <TableRow key={index} sx={{ border: "1px solid black" }}>
                  <TableCell
                    align="center"
                    sx={{
                      border: "1px solid black",
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                      backgroundColor: "white", // importante para que no se vea el scroll atrás
                    }}
                  >
                    {tanque}
                  </TableCell>
                  {meses.map((mes, mesIndex) => (
                    <TableCell
                      key={mesIndex}
                      align="center"
                      sx={{ border: "1px solid black" }}
                    >
                      {dataset.find((item) => item.tanque === tanque)?.[mes] ||
                        0}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

export default Tabla_tanque;
